module.exports = __webpack_public_path__ + "static/media/apercu-regular_italic.27c1822c.woff";